export enum AgentStates {
  Available = 'available',
  Unavailable = 'unavailable',
  InboundContact = 'inboundContact',
  OutboundContact = 'outboundContact',
  InboundConsult = 'inboundConsult',
  OutboundConsult = 'outboundConsult',
  Dialer = 'dialer',
  DialerPending = 'dialerPending',
}
